"use client"
import { useEffect } from "react"
import { useHoverContext } from "../contexts/HoverContext"

export default function HoverManager() {
  const { setHoverTarget } = useHoverContext()

  useEffect(() => {
    const handleMouseOver = (e: MouseEvent) => {
      const target = (e.target as HTMLElement)?.closest("[data-target], a, button")

      if (!target) return setHoverTarget(null)

      const dataTarget = target.getAttribute("data-target")
      const tagName = target.tagName

      if (dataTarget) {
        setHoverTarget(dataTarget)
      } else if (tagName === "A") {
        setHoverTarget("link")
      } else if (tagName === "BUTTON") {
        setHoverTarget("button")
      } else {
        setHoverTarget(null)
      }
    }

    const handleMouseOut = (e: MouseEvent) => {
      // When mouse leaves any known interactive area, reset hover
      const related = (e.relatedTarget as HTMLElement)?.closest("[data-target], a, button")
      if (!related) {
        setHoverTarget(null)
      }
    }

    document.addEventListener("mouseover", handleMouseOver)
    document.addEventListener("mouseout", handleMouseOut)

    return () => {
      document.removeEventListener("mouseover", handleMouseOver)
      document.removeEventListener("mouseout", handleMouseOut)
    }
  }, [setHoverTarget])

  return null
}
